// Core packages
import { Injectable } from "@angular/core";

// Third party packages
import { Observable } from "rxjs";

// Custom packages
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root"
})
export class FileService {
  /**
   * Class constructor
   */
  constructor(private apiService: ApiService) {}

  /**
   * Upload file
   *
   * @since 1.0.0
   *
   * @returns Observable<any>
   */
  uploadImportingFiles(file: FormData, endpoint?: string): Observable<any> {
    if (endpoint && endpoint === 'supplier') {
      return this.apiService.apiCall("POST", "temp-files", file, {
        contentType: "auto"
      },true, true);  
    }
    return this.apiService.apiCall("POST", "files", file, {
      contentType: "auto"
    });
  }
}
